import { render } from "./AccountMenu.vue?vue&type=template&id=256148a4"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
script.render = render

export default script